module.exports = __webpack_public_path__ + "img/17-1.41dd4922.png";